import { render, staticRenderFns } from "./AnnouncementsIndicator.vue?vue&type=template&id=a6ded350"
import script from "./AnnouncementsIndicator.vue?vue&type=script&lang=js"
export * from "./AnnouncementsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports